import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotActivities from './components/HotActivities';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/articles';

export default function Home() {
  useEffect(() => {
    document.title = `${siteInfo.tagline} | ${siteInfo.name}`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', siteInfo.description);
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.setAttribute('content', siteInfo.keywords);
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteInfo.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteInfo.address,
      addressLocality: '广州市',
      addressRegion: '广东省',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotActivities />
          <LatestArticles />
          <FAQSection />
          <section className="py-12 md:py-16 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
              <div className="bg-primary-50 rounded-lg p-8 md:p-10 border border-primary-200/60">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  准备好领取你的专属彩金了吗？
                </h2>
                <p className="text-sm text-foreground-600 mb-6 max-w-xl mx-auto">
                  立即注册优质平台，领取新人专属彩金福利。名额有限，先到先得！
                </p>
                <Link
                  to="/category/platform-recommend"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                >
                  查看推荐平台
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}